export default "__VITE_ASSET__Dm2H6CJX__"